import PropTypes from 'prop-types';
import React from 'react';
import { get } from 'lodash';
import { Router, applyRouterMiddleware } from 'react-router';
import { browserHistory } from 'common/utils/browserHistory';
import { Provider } from 'react-redux';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { Tracker } from '@unite-us/client-utils';
import { useScroll } from 'react-router-scroll';
import configAuthenticatedRoutes from 'src/pages/routes';
import { env } from 'src/config/env';
import FeatureFlagDevTools from 'src/common/utils/FeatureFlagsDevTools';
import { collectOwnershipFromRoutes } from 'src/components/App/utils/instrumentRouteOwnership';

const queryClient = new QueryClient();

const ProviderUS = (props) => {
  const {
    store,
  } = props;

  const getTrackerConfig = () => {
    const state = store.getState();
    return {
      url: env.TRACKING_URL,
      user: get(state, 'user'),
      analytics_proxy_url: get(state, 'session.app_support.app.analytics_proxy_url', null),
      groupId: get(state, 'session.groupId'),
      impersonationType: get(state, 'session.impersonationType'),
      isCC: get(state, 'session.isCoordinationGroup'),
    };
  };

  const routes = configAuthenticatedRoutes(store);

  // Populates a config object used in dataDogHelper.js
  collectOwnershipFromRoutes(routes);

  return (
    <Provider store={store}>
      <Tracker source="app-client" getConfig={getTrackerConfig}>
        <QueryClientProvider client={queryClient}>
          <Router
            history={browserHistory}
            routes={routes}
            render={applyRouterMiddleware(useScroll())}
            basename={env.ROUTE_BASEPATH === '/' ? '' : env.ROUTE_BASEPATH}
          />
          <FeatureFlagDevTools />
        </QueryClientProvider>
      </Tracker>
    </Provider>
  );
};

ProviderUS.propTypes = {
  store: PropTypes.object.isRequired,
};

export default ProviderUS;
